/* eslint-disable func-style */
// 发票管理
const InvoicePrinting = () => import('@/pages/InvoiceManagement/InvoicePrinting.vue');
const InvoicePrintDetail = () => import('@/pages/InvoiceManagement/InvoicePrintDetail.vue');
const InvoiceMaintenance = () => import('@/pages/InvoiceManagement/InvoiceMaintenance.vue');
const InvoiceMainDetail = () => import('@/pages/InvoiceManagement/InvoiceMainDetail.vue');
const RefundInvoicePrinting = () => import('@/pages/InvoiceManagement/RefundInvoicePrinting.vue');
const RefundInvoiceDetail = () => import('@/pages/InvoiceManagement/RefundInvoiceDetail.vue');
const RefundMaintenance = () => import('@/pages/InvoiceManagement/RefundMaintenance.vue');
const RefundMainDetail = () => import('@/pages/InvoiceManagement/RefundMainDetail.vue');
const BillMaintenance = () => import('@/pages/InvoiceManagement/BillMaintenance.vue');
const ElectronicInvoiceInvoicing = () => import('@/pages/InvoiceManagement/ElectronicInvoiceInvoicing.vue');
const ElectronicInvoiceInvoicingDetail = () => import('@/pages/InvoiceManagement/ElectronicInvoiceInvoicingDetail.vue');// 电子发票开票详情
const ELectricQuery = () => import('../pages/InvoiceManagement/ElectricQuery.vue');
const ElectricQueryDetail = () => import('../pages/InvoiceManagement/ElectricQueryDetail.vue');
const RightPanel = () => import('@/components/RightPanel.vue');// 右滑详情页面
const InvoicePointManage = () => import('@/pages/InvoiceManagement/InvoicePointManage.vue');// 开票点管理


const ReceiptRouter = [
	{
		path: '/ELectricQuery',
		name: 'ELectricQuery',
		component: ELectricQuery,
		children: [
			{
				path: '/ELectricQueryRightPanel',
				name: 'ELectricQueryRightPanel',
				component: RightPanel,
				meta: { parent: '/ELectricQuery' },
				children: [
					{
						// 右滑详情页面
						path: '/ELectricQueryDetail/:details',
						name: 'ELectricQueryDetail',
						component: ElectricQueryDetail,
						meta: { parent: '/ELectricQuery' },
					},
				],
			},
		],
	},
	{
		path: '/InvoicePrinting',
		name: 'InvoicePrinting',
		component: InvoicePrinting,
		children: [
			{
				path: '/InvoicePrintRightPanel',
				name: 'InvoicePrintRightPanel',
				component: RightPanel,
				meta: { parent: '/InvoicePrinting' },
				children: [
					{ // 右滑详情页面
						path: '/InvoicePrintDetail/:details',
						name: 'InvoicePrintDetail',
						component: InvoicePrintDetail,
						meta: { parent: '/InvoicePrinting' },
					},
				],
			},
		],
	}, // 收款打印
	{
		path: '/InvoiceMaintenance',
		name: 'InvoiceMaintenance',
		component: InvoiceMaintenance,
		children: [
			{
				path: '/InvoiceMainRightPanel',
				name: 'InvoiceMainRightPanel',
				meta: { parent: '/InvoiceMaintenance' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/InvoiceMainDetail/:details',
						name: 'InvoiceMainDetail',
						meta: { parent: '/InvoiceMaintenance' },
						component: InvoiceMainDetail,
					},
				],
			},
		],
	}, // 收款维护
	{
		path: '/RefundInvoicePrinting',
		name: 'RefundInvoicePrinting',
		component: RefundInvoicePrinting,
		children: [
			{
				path: '/RefundPrintingRightPanel',
				name: 'RefundPrintingRightPanel',
				meta: { parent: '/RefundInvoicePrinting' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/RefundInvoiceDetail/:details',
						name: 'RefundInvoiceDetail',
						meta: { parent: '/RefundInvoicePrinting' },
						component: RefundInvoiceDetail,
					},
				],
			},
		],
	}, // 退款打印
	{
		path: '/RefundMaintenance',
		name: 'RefundMaintenance',
		component: RefundMaintenance,
		children: [
			{
				path: '/RefundMainRightPanel',
				name: 'RefundMainRightPanel',
				meta: { parent: '/RefundMaintenance' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/RefundMainDetail/:details',
						meta: { parent: '/RefundMaintenance' },
						name: 'RefundMainDetail',
						component: RefundMainDetail,
					},
				],
			},
		],
	}, // 退款维护
	{
		path: '/ElectronicInvoiceInvoicing',
		name: 'ElectronicInvoiceInvoicing',
		component: ElectronicInvoiceInvoicing,
		children: [
			{
				path: '/ElectronicInvoiceInvoicingRightPanel',
				name: 'ElectronicInvoiceInvoicingRightPanel',
				meta: { parent: '/ElectronicInvoiceInvoicing' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/ElectronicInvoiceInvoicingDetail/:details',
						meta: { parent: '/ElectronicInvoiceInvoicing' },
						name: 'ElectronicInvoiceInvoicingDetail',
						component: ElectronicInvoiceInvoicingDetail,
					},
				],
			},
		],
	}, // 电子发票开票
	{ path: '/BillMaintenance', name: 'BillMaintenance', component: BillMaintenance }, // 电子发票维护
	{ path: '/InvoicePointManage', name: 'InvoicePointManage', component: InvoicePointManage }, // 开票点管理
];

export default ReceiptRouter;
